import React from 'react'
import timeFormatter from 'helpers/timeFormatter'

export const mediaList = t => [
	{
		Header: <span className='sort-icons'>{t('common.fields.time')}</span>,
		accessor: 'fromTime',
		Cell: ({ value }) => timeFormatter(value, 'HH:mm'),
		width: 90
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}
]

export const listProducts = t => [
	{
		accessor: 'id',
		show: false
	},
	{
		Header: t('common.fields.code'),
		accessor: 'code'
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}
]
